/* ==========================================================================
   Mouse Animation
   ========================================================================== */

// ...
import gsap from "gsap";
import DrawSVGPlugin from "gsap/DrawSVGPlugin";
import CustomEase from "gsap/CustomEase";

gsap.registerPlugin(DrawSVGPlugin, CustomEase);

gsap.config({ nullTargetWarn: false });

gsap.set(".line", { transformOrigin: "center center" });

let afterFadeIn;

afterFadeIn = () => {
  gsap
    .timeline({
      epeatRefresh: true,
    })
    .from(".line", {
      opacity: 1,
    })
    .to(".line", {
      opacity: 0,
      repeat: -1,
      duration: 1.5,
      yoyo: true,
      ease: "slow",
    });
};

const timeline = gsap
  .timeline({ repeatRefresh: true })
  .from(".line", {
    scale: 0,
    yPercent: -40,
    duration: 1.5,
    opacity: 1,
    onComplete: afterFadeIn,
  })
  .fromTo("#line", { drawSVG: "0% 0%" }, { drawSVG: "0% 100%" });

window.addEventListener("load", function () {
  timeline.restart();
});
